<script setup lang="ts">
import { storeToRefs } from "pinia";
import { useDownloadPlatformIdCard } from "~/core/composables/useDownloadPlatformIdCard";
import { useOrganizationStore } from "~/modules/organization/stores/useOrganizationStore";
import ILxcDownload from "~icons/lxc/download";

const { t } = useI18n();

const props = defineProps<{
  organizationCode?: number;
  businessUnitCode?: number;
}>();

const { currentOrganization } = storeToRefs(useOrganizationStore());

const organizationCodeToDownload = computed(
  () => props.organizationCode ?? currentOrganization.value?.code,
);

const {
  downloadPlatformIdCard,
  isLoading: isLoadingDownloadIdCard,
  canDownloadPlatformIdCard,
} = useDownloadPlatformIdCard({
  organizationCode: organizationCodeToDownload.value,
  businessUnitCode: props.businessUnitCode,
});
</script>

<template>
  <lxc-button
    v-if="canDownloadPlatformIdCard()"
    type="tertiary"
    :title="t('license.idCard.export.title')"
    :icon="ILxcDownload"
    :is-loading="isLoadingDownloadIdCard"
    @click="downloadPlatformIdCard"
  >
    {{ t("license.idCard.export.text") }}
  </lxc-button>
</template>
